<template>
  <div class="min-h-screen bg-bg-cream">
    <Navbar />
    <slot />
    <Footer />
  </div>
</template>

<script setup>
// Default layout for all pages
</script>

<style scoped>
/* Add custom fonts */
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap');
</style>
